class HeaderMenuDropdown extends HTMLElement {
  constructor() {
    super()
    this.boundCheckPosition = this.checkPosition.bind(this)
  }

  connectedCallback() {
    this.initializeProperties()
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  initializeProperties() {
    this.dropdownContent = this.querySelector('.dropdown-content')
    this.dropdownContentItem = this.querySelector('.dropdown-content-item')
    this.dropdownColumn = this.querySelector('.dropdown-column')
  }

  addEventListeners() {
    this.addEventListener('mouseenter', this.boundCheckPosition)
  }

  removeEventListeners() {
    this.removeEventListener('mouseenter', this.boundCheckPosition)
  }

  checkPosition() {
    const { overflowAmount, dropdownColumnWidth } = this.calculateOverflow()
    this.updateDropdownPosition(overflowAmount, dropdownColumnWidth)
  }

  calculateOverflow() {
    const { left: dropdownPosition } = this.getBoundingClientRect()
    const { offsetWidth: dropdownContentWidth } = this.dropdownContent
    const { offsetWidth: dropdownColumnWidth } = this.dropdownColumn
    const dropdownContentPosition = dropdownPosition + dropdownContentWidth + 20
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth
    const overflowAmount = dropdownContentPosition - viewportWidth

    return { overflowAmount, dropdownColumnWidth }
  }

  updateDropdownPosition(overflowAmount, dropdownColumnWidth) {
    const { left, right } = this.calculatePosition(overflowAmount, dropdownColumnWidth)
    this.setDropdownStyle(left, right)
  }

  calculatePosition(overflowAmount, dropdownColumnWidth) {
    if (overflowAmount <= 0) {
      return { left: '0', right: 'auto' }
    }

    if (overflowAmount > dropdownColumnWidth / 3) {
      return { left: 'auto', right: '0' }
    }

    return { left: `-${overflowAmount}px`, right: 'auto' }
  }

  setDropdownStyle(left, right) {
    Object.assign(this.dropdownContent.style, { left, right })
    this.dropdownContentItem.style.flexDirection = 'row'
  }
}

customElements.define('header-menu-dropdown', HeaderMenuDropdown)
